import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(targetDate) - new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="flex gap-4 justify-center sm:justify-start">
      <div className="text-center">
        <div className="bg-crimson text-white font-outfit font-800 text-2xl sm:text-3xl px-4 py-3 rounded-lg min-w-[70px]">
          {timeLeft.days}
        </div>
        <p className="text-gray-400 font-outfit font-600 text-xs mt-2">DAYS</p>
      </div>
      <div className="text-center">
        <div className="bg-crimson text-white font-outfit font-800 text-2xl sm:text-3xl px-4 py-3 rounded-lg min-w-[70px]">
          {timeLeft.hours}
        </div>
        <p className="text-gray-400 font-outfit font-600 text-xs mt-2">HOURS</p>
      </div>
      <div className="text-center">
        <div className="bg-crimson text-white font-outfit font-800 text-2xl sm:text-3xl px-4 py-3 rounded-lg min-w-[70px]">
          {timeLeft.minutes}
        </div>
        <p className="text-gray-400 font-outfit font-600 text-xs mt-2">MINS</p>
      </div>
      <div className="text-center">
        <div className="bg-crimson text-white font-outfit font-800 text-2xl sm:text-3xl px-4 py-3 rounded-lg min-w-[70px]">
          {timeLeft.seconds}
        </div>
        <p className="text-gray-400 font-outfit font-600 text-xs mt-2">SECS</p>
      </div>
    </div>
  );
};

export default CountdownTimer;
